import { Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { AuthenticatedPage } from '../components/AuthenticatedPage';
import { Availability } from '../components/CareerRoadMap/Availability';
import { CareerRoadMapHeader } from '../components/CareerRoadMap/CareerRoadMapHeader';
import { Certification } from '../components/CareerRoadMap/Certification';
import { ContextNotes } from '../components/CareerRoadMap/ContextNotes';
import { DetailOrientation } from '../components/CareerRoadMap/DetailOrientation';
import { DigitalLiteracy } from '../components/CareerRoadMap/DigitalLiteracy';
import { GreenOrientation } from '../components/CareerRoadMap/GreenOrientation';
import { Location } from '../components/CareerRoadMap/Location';
import { Motivation } from '../components/CareerRoadMap/Motivation';
import { OpsScenario } from '../components/CareerRoadMap/OpsScenario';
import { PeopleScenario } from '../components/CareerRoadMap/PeopleScenario';
import { PhysicalityScore } from '../components/CareerRoadMap/PhysicalityScore';
import { ProblemSolvingAndDescisonMaking } from '../components/CareerRoadMap/ProblemSolving';
import { SectorInterest } from '../components/CareerRoadMap/SectorInterest';
import { StructuredContext } from '../components/CareerRoadMap/StructuredContext';
import { StructurePreference } from '../components/CareerRoadMap/StructurePreference';
import { ToolExposure } from '../components/CareerRoadMap/ToolExposure';
import { dispatchGetCareerRoadMapAssessment } from '../redux/slice/career-roadmap/career-roadmap.operations';
import { dispatchGetIntakeFormValues } from '../redux/slice/form-intake/form-intake.operations';
import { dispatchUpsertPreEmploymentAssessment } from '../redux/slice/pre-employment-assessment';
import { dispatchGetUserProfileValues } from '../redux/slice/user-profile';
import { useAppDispatch } from '../redux/store';

export const CareerRoadMap: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { componentName } = useParams();

  const [step, setStep] = useState(1);
  const handleBackButton = () => {
    navigate(`/career-roadmap/step${step - 1}`);
  };

  useEffect(() => {
    void dispatch(dispatchGetIntakeFormValues());
    void dispatch(dispatchUpsertPreEmploymentAssessment());

    void dispatch(dispatchGetCareerRoadMapAssessment());
    void dispatch(dispatchGetUserProfileValues());
  }, []);
  const renderFormStep = () => {
    switch (componentName) {
      case 'step2':
        return <Location step={step} onBack={handleBackButton} />; //0
      case 'step3':
        return <Motivation step={step} onBack={handleBackButton} />; // 1,2
      case 'step4':
        return <DigitalLiteracy step={step} onBack={handleBackButton} />; // 3
      case 'step5':
        return <ToolExposure step={step} onBack={handleBackButton} />; //4
      case 'step6':
        return <SectorInterest step={step} onBack={handleBackButton} />; // 5
      case 'step7':
        return <PeopleScenario step={step} onBack={handleBackButton} />; // 6
      case 'step8':
        return <OpsScenario step={step} onBack={handleBackButton} />; // 7
      case 'step9':
        return <ProblemSolvingAndDescisonMaking step={step} onBack={handleBackButton} />; // 8
      case 'step10':
        return <DetailOrientation step={step} onBack={handleBackButton} />; //10
      case 'step11':
        return <PhysicalityScore step={step} onBack={handleBackButton} />; // 11, 12, 13
      case 'step12':
        return <StructurePreference step={step} onBack={handleBackButton} />; //14
      case 'step13':
        return <Availability step={step} onBack={handleBackButton} />; // 15
      case 'step14':
        return <Certification step={step} onBack={handleBackButton} />; // 16
      case 'step15':
        return <GreenOrientation step={step} onBack={handleBackButton} />; //21
      case 'step16':
        return <StructuredContext step={step} onBack={handleBackButton} />; // 18,19,20
      case 'step17':
        return <ContextNotes step={step} onBack={handleBackButton} />; //21

      default:
        navigate('/career-roadmap/step2');
        return null;
    }
  };

  useEffect(() => {
    setStep(parseInt(componentName?.replace('step', '') || '1'));
    window.scrollTo(0, 0);
  }, [componentName]);

  return (
    <div className={`steps overflow-hidden relative skills-${step}`}>
      <Container>
        <>
          {' '}
          <CareerRoadMapHeader step={step}>
            <>{renderFormStep()}</>
          </CareerRoadMapHeader>
        </>
      </Container>
    </div>
  );
};

export const CareerRoadMapPage: React.FC = () => {
  return <AuthenticatedPage render={() => <CareerRoadMap />} />;
};
